import React from "react";
import ApplicantCredentialTableRow from "../TableRows/ApplicantCredentialTableRow";
import { MdOutlineArrowBack } from "react-icons/md";
import { Link } from "react-router-dom";

function ApplicantCredentialTable() {
  return (
    <div>
      <div className="mt-4">
        <div className="flex flex-col py-4 px-[24px]  rounded-t-lg bg-white">
          <div className="">
            <Link to={"/dashboard/applicants"}>
              <MdOutlineArrowBack size="24px" />
            </Link>
          </div>

          <div className=" flex flex-col md:flex-row justify-between pt-[36px]   bg-white">
            <p className="text-[24px]">Credentials</p>
            <div className="text-[#1E87FF]  flex gap-2 items-center">
              <p className="text-[14px]">Edit</p>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0002 15.1663H6.00016C2.38016 15.1663 0.833496 13.6197 0.833496 9.99967V5.99967C0.833496 2.37967 2.38016 0.833008 6.00016 0.833008H7.3335C7.60683 0.833008 7.8335 1.05967 7.8335 1.33301C7.8335 1.60634 7.60683 1.83301 7.3335 1.83301H6.00016C2.92683 1.83301 1.8335 2.92634 1.8335 5.99967V9.99967C1.8335 13.073 2.92683 14.1663 6.00016 14.1663H10.0002C13.0735 14.1663 14.1668 13.073 14.1668 9.99967V8.66634C14.1668 8.39301 14.3935 8.16634 14.6668 8.16634C14.9402 8.16634 15.1668 8.39301 15.1668 8.66634V9.99967C15.1668 13.6197 13.6202 15.1663 10.0002 15.1663Z"
                  fill="#1E87FF"
                />
                <path
                  d="M5.66688 11.7934C5.26022 11.7934 4.88688 11.6467 4.61355 11.38C4.28688 11.0534 4.14688 10.58 4.22022 10.08L4.50688 8.07337C4.56022 7.68671 4.81355 7.18671 5.08688 6.91337L10.3402 1.66004C11.6669 0.333372 13.0135 0.333372 14.3402 1.66004C15.0669 2.38671 15.3935 3.12671 15.3269 3.86671C15.2669 4.46671 14.9469 5.05337 14.3402 5.65337L9.08688 10.9067C8.81355 11.18 8.31355 11.4334 7.92688 11.4867L5.92022 11.7734C5.83355 11.7934 5.74688 11.7934 5.66688 11.7934ZM11.0469 2.36671L5.79355 7.62004C5.66688 7.74671 5.52022 8.04004 5.49355 8.21337L5.20688 10.22C5.18022 10.4134 5.22022 10.5734 5.32022 10.6734C5.42022 10.7734 5.58022 10.8134 5.77355 10.7867L7.78022 10.5C7.95355 10.4734 8.25355 10.3267 8.37355 10.2L13.6269 4.94671C14.0602 4.51337 14.2869 4.12671 14.3202 3.76671C14.3602 3.33337 14.1335 2.87337 13.6269 2.36004C12.5602 1.29337 11.8269 1.59337 11.0469 2.36671Z"
                  fill="#1E87FF"
                />
                <path
                  d="M13.2335 6.55319C13.1869 6.55319 13.1402 6.54652 13.1002 6.53319C11.3469 6.03986 9.95353 4.64652 9.4602 2.89319C9.38687 2.62652 9.5402 2.35319 9.80687 2.27319C10.0735 2.19986 10.3469 2.35319 10.4202 2.61986C10.8202 4.03986 11.9469 5.16652 13.3669 5.56652C13.6335 5.63986 13.7869 5.91985 13.7135 6.18652C13.6535 6.41319 13.4535 6.55319 13.2335 6.55319Z"
                  fill="#1E87FF"
                />
              </svg>
            </div>
          </div>
        </div>
        <ApplicantCredentialTableRow />
      </div>
    </div>
  );
}

export default ApplicantCredentialTable;
